<script>

export default {
  name:"GoogleMapMarker",
  data(){
    return {
      m:null
    }
  },
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    }
  },
  methods:{
    toggleBounce() {
      if (this.m.getAnimation() !== null) {
        this.m.setAnimation(null);
      } else {
        this.m.setAnimation(this.google.maps.Animation.BOUNCE);
      }
    }
  },
  mounted() {
    const { Marker } = this.google.maps;

    this.m = new Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      // icon: POINT_MARKER_ICON_CONFIG
      animation: this.google.maps.Animation.DROP,
    });
    setTimeout(()=>{
      this.toggleBounce()
    }, 1000)

  },

  render() {}
};
</script>
